import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol, VAppBarNavIcon, VToolbarTitle, VBtn, VIcon, VSimpleTable } from "vuetify/lib";
import DemoSection from '../../components/DemoSection.vue';
import CodePreview from '../../components/CodePreview.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosToolbarDemo',
    setup(__props) {
        const propsDocs = ref([
            { name: 'title', type: 'string', desc: 'Establece el título principal de la barra de herramientas.', default: '""' },
            { name: 'color', type: 'string', desc: 'Aplica un color de fondo a la barra de herramientas (ej. "primary", "red lighten-2").', default: '""' },
            { name: 'flat', type: 'boolean', desc: 'Elimina la elevación (sombra) de la barra de herramientas.', default: 'false' },
            { name: 'dense', type: 'boolean', desc: 'Reduce la altura de la barra de herramientas.', default: 'false' },
            { name: 'height', type: 'string | number', desc: 'Define una altura personalizada para la barra de herramientas.', default: 'undefined' },
            { name: 'dark', type: 'boolean', desc: 'Aplica el tema oscuro a la barra de herramientas.', default: 'false' },
        ]);
        const slotsDocs = ref([
            { name: 'prepend', desc: 'Contenido que se muestra al inicio de la barra de herramientas (ej. icono de navegación).' },
            { name: 'default', desc: 'Contenido principal de la barra de herramientas (ej. título, elementos centrados).' },
            { name: 'append', desc: 'Contenido que se muestra al final de la barra de herramientas (ej. botones de acción).' },
        ]);
        return { __sfc: true, propsDocs, slotsDocs, VContainer, VRow, VCol, VAppBarNavIcon, VToolbarTitle, VBtn, VIcon, VSimpleTable, DemoSection, CodePreview };
    }
});
